import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4203950e = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _50d75bb4 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _a7fca54c = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _a7e0764a = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _a7a81846 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _a78be944 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _3e302eca = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _c98fd17a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _4203950e,
    name: "error"
  }, {
    path: "/success",
    component: _50d75bb4,
    name: "success"
  }, {
    path: "/errors/400",
    component: _a7fca54c,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _a7e0764a,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _a7a81846,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _a78be944,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _3e302eca,
    name: "errors-500"
  }, {
    path: "/",
    component: _c98fd17a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
